import { useDispatch } from "react-redux";

import { MainButton } from "../../components/MainButton";
import { updateModal } from "../../store/mainReducer";
import { COLORS } from "../../utils/colors";

const RegisterPending = () => {
  const dispatch = useDispatch();

  const handleLogin = () => {
    dispatch(updateModal("loginView"));
  };

  return (
    <div className="container-column" style={{ alignItems: "center" }}>
      <p id="login-header">Registration pending...</p>
      <span style={{ marginBottom: "0px" }}>Check your E-Mail.</span>
      <span style={{ marginBottom: "40px" }}>
        Be sure to also look in the Spam folder.
      </span>
      <span style={{ marginBottom: "20px" }}>Confirmed your e-mail?</span>
      <MainButton
        text="Login"
        onClickAction={handleLogin}
        color={COLORS.black}
        textColor={COLORS.white}
      />
    </div>
  );
};

export default RegisterPending;
